import { DragEvent } from 'react';

type BlockedFileDropProps = {
  onDragOver?: (event: DragEvent<HTMLElement>) => void;
  onDrop?: (event: DragEvent<HTMLElement>) => void;
};

function onBlockedFileDrag(event: DragEvent<HTMLElement>): void {
  event.preventDefault();
}

const NO_BLOCKED_DROP_PROPS: BlockedFileDropProps = Object.freeze({});
const BLOCKED_DROP_PROPS: BlockedFileDropProps = Object.freeze({ onDragOver: onBlockedFileDrag, onDrop: onBlockedFileDrag });

// Sin `preventDefault` el drop burbujea hasta el documento y el navegador abre el fichero, sacando al usuario de la vista
function getBlockedFileDropProps(isBlocked: boolean): BlockedFileDropProps {
  return isBlocked ? BLOCKED_DROP_PROPS : NO_BLOCKED_DROP_PROPS;
}

export default getBlockedFileDropProps;
